/**
 * Lowercase, strip accents, remove spaces/punctuation so "tshirt" aligns with "t-shirt".
 */
export const normalizeSearchKey = (s: string): string =>
  s
    .toLowerCase()
    .normalize('NFD')
    .replace(/\p{M}/gu, '')
    .replace(/[^\p{L}\p{N}]/gu, '')

/**
 * ilike pattern where each character may be separated by arbitrary text (hyphens, spaces).
 * e.g. "tshi" -> "%t%s%h%i%" matches "T-Shirt", "t-shirt".
 */
export const buildSequentialIlikePattern = (term: string): string => {
  const lower = term.toLowerCase().trim()
  if (!lower) return '%%'
  const esc = (ch: string) => {
    if (ch === '%') return '\\%'
    if (ch === '_') return '\\_'
    if (ch === '\\') return '\\\\'
    return ch
  }
  return '%' + [...lower].map(esc).join('%') + '%'
}
